module.exports = __webpack_public_path__ + "img/qianghuawuguanli.58a47337.png";